"use client";

import { useEffect } from "react";
import Script from "next/script";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";

const STYLE_ID = "zendesk-mobile-hide";
const LAUNCHER_SELECTOR = "#launcher, [id*='zendesk']";

/**
 * Zendesk 在线客服组件
 * - PC：始终显示 launcher icon，关闭聊天后 icon 不消失
 * - Mobile：隐藏 launcher，用户点击在线客服时调 zE('messenger', 'open') 打开
 */
const Zendesk = () => {
  const { isMobile } = useAppSelector((state: RootState) => state.app);

  useEffect(() => {
    if (isMobile) {
      // Mobile：注入 CSS 隐藏 launcher icon
      if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement("style");
        style.id = STYLE_ID;
        style.textContent = `
          ${LAUNCHER_SELECTOR} {
            display: none !important;
          }
        `;
        document.head.appendChild(style);
      }
    } else {
      // PC：移除隐藏 CSS
      const style = document.getElementById(STYLE_ID);
      if (style) style.remove();

      // 强制确保 launcher 可见
      const forceLauncherVisible = () => {
        const launcher = document.getElementById("launcher");
        if (launcher) {
          if (launcher.style.display === "none" || launcher.style.visibility === "hidden") {
            launcher.style.display = "";
            launcher.style.visibility = "visible";
          }
        }
        if (typeof window.zE === "function") {
          try { zE("messenger", "show"); } catch (e) {}
        }
      };

      forceLauncherVisible();
      const t1 = setTimeout(forceLauncherVisible, 500);
      const t2 = setTimeout(forceLauncherVisible, 1500);

      // MutationObserver：Zendesk 关闭聊天时会隐藏 launcher，强制恢复
      const observer = new MutationObserver(() => {
        const launcher = document.getElementById("launcher");
        if (launcher && (launcher.style.display === "none" || launcher.style.visibility === "hidden")) {
          launcher.style.display = "";
          launcher.style.visibility = "visible";
        }
      });

      const startObserver = setTimeout(() => {
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["style"],
          subtree: true,
          childList: true,
        });
      }, 2000);

      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
        clearTimeout(startObserver);
        observer.disconnect();
      };
    }
  }, [isMobile]);

  return (
    <Script
      src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/cmsv2/cdn/chat-tool/index_new.umd.js"
      strategy="afterInteractive"
    />
  );
};

export default Zendesk;
